export const state = {
    appName: "BETFLIX768",
    user: {
        wallet: {},
        roles: [""]
    },
    error: null,
    loading: false,
    access_token: null,
    isAuth: false,
    lang: "en-US"
}